<template>
  <div class="summit">
    <!-- <div class="banner">
      <div class="w"> -->
        <!-- <img width="100%" src="../assets/img/summit/mettings.png" alt=""> -->
        <!-- <div class="banner_icon"></div>
        <p class="en">
          The 3rd China Industry Finance Supply Chain Elite Summit
        </p>
        <h1>第三届中国产融供应链精英峰会</h1>
        <p class="date">
          2021.12.17&nbsp;&nbsp;&nbsp;&nbsp;深圳市福田区香格里拉大酒店
        </p>
        <div class="banner_btn">
          <div>
            <a
              style="color: red"
              href="http://iportal.zhongpukeji.cn/#/login"
              target="_blank"
              >我要参会</a
            >
          </div>
          <div>
            <a
              style="color: red"
              href="http://iportal.zhongpukeji.cn/#/login"
              target="_blank"
              >我要布展</a
            >
          </div>
        </div> -->
      <!-- </div>
    </div> -->
    <div class="videoWrap">
      <!-- <img src="../assets/img/summit/metting_title.png" height="70px" alt=""> -->

      <div class="video-box">
        <div class="video-left">
          <!-- <div class="title">海平创新为龙江交投集团打造“龙贸通”中俄国际物贸综合服务平台</div> -->
          <img width="100%" src="../assets/img/summit/lmt.png" alt="">
          <div class="content">
            <p>&nbsp;&nbsp;&nbsp;&nbsp;交投国际物贸集团开发建设“龙贸通”中俄国际物贸综合服务平台，以市场化方式服务对俄国际物贸产业发展。7月30日，交投集团召开“龙贸通”中俄国际物贸综合服务平台上线试运行发布会。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;本次发布活动还邀请了众多业界专家，其中，中国产业链与供应链专家李海平相继围绕外贸综合服务平台与外贸企业转型发展、产业链供应链平台创新等内容发表主旨宣讲，为到场嘉宾带来了干货满满、诚意满满的“行业大咖视角”。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;“龙贸通”中俄国际物贸综合服务平台是“全链条、一站式”的外贸综合服务平台，是面向俄罗斯、东北亚的跨境物贸门户。
              <!-- 平台服务于“买全俄、卖全国，买全国、卖全俄”发展目标，以贸易商机、报关报检、物流仓储、退税结算、商务对接、孵化培训、金融信保、贸易展会、政策解读等中俄贸易全流程市场化综合服务为基础，构建“市场服务+增值服务+公共服务”三位一体的数字化服务体系，有效促进贸易主体、贸易对象、贸易方式、贸易服务四大方面实现数字化转型。 -->
            </p>
          </div>
        </div>
        <div class="video-right">
          <video
            src="http://gitlab.zhongpukeji.cn/video/%E9%BE%99%E8%B4%B8%E9%80%9A.mp4"
            controls="controls"
            autoplay
            loop
          ></video>
        </div>
      </div>

      <div class="video-box-row">
        <div class="video-item">
          <div class="title">盐湖股份</div>
            <video
              src="http://gitlab.zhongpukeji.cn/video/%E7%9B%90%E6%B9%96%E5%95%86%E8%B4%B8%E4%BA%91.mp4"
              controls="controls"
              autoplay
              loop
            ></video>
        </div>
        <div class="video-item">
          <div class="title">四川港投</div>
            <video
              src="http://gitlab.zhongpukeji.cn/video/%E5%9B%9B%E5%B7%9D%E6%B8%AF%E6%8A%95.mp4"
              controls="controls"
              autoplay
              loop
            ></video>
        </div>
      </div>

      <div class="videoBx">
        <video
          src="http://gitlab.zhongpukeji.cn/video/meeting.mp4"
          controls="controls"
          autoplay
          loop
        ></video>
      </div>
    </div>
    
    <div class="expert">
      <div class="w" style="width: 1248px;">
        <div class="expert_icon"></div>
        <h2 class="c_h2">
          特邀专家
        </h2>
        <p class="c_p">
          峰会邀请行业内最权威的专家与重量级嘉宾，为广大精英们奉献出一次次精彩绝伦的视听盛宴<br />
          了解实战干货、收获先进理论，聆听大咖思想、学习前沿科技
        </p>
      </div>
    </div>
    <div class="imgList">
      <img class="bg" src="../assets/img/summit/fhbg.png" alt="" />
      <div class="w" id="ImgList" style="max-width: 1200px">
        <div class="item" v-for="(item, i) in list" :key="i">
          <div class="imgBx">
            <img width="100%" :src="item.url" alt="" />
          </div>
          <h5>{{ item.name }}</h5>
          <p>{{ item.desc }}</p>
        </div>
      </div>
    </div>
    <!-- <div class="enterprise">
      <div class="w">
        <div class="expert_icon"></div>
        <h2 class="c_h2">
          企业宣传
        </h2>
        <p class="c_p">
          在数百人的会场，参会精英们可以通过搭建展台、制作材料、摆放易拉宝、会场大屏展示、会场长廊屏幕投放等各色渠道<br />
          进行企业的宣传，让最精确的产品信息触达最精确的用户
        </p>
        <div class="swiper-container" style="margin-top:50px">
          <div class="swiper-slide">
            <img src="../assets/img/summit/swiper.png" alt="" />
          </div>
          <div class="swiper-button-next"></div>
          <div class="swiper-button-prev"></div>
        </div>
      </div>
    </div> -->
    <div class="communication">
      <div class="w">
        <div class="expert_icon"></div>
        <h2 class="c_h2">
          交流学习
        </h2>
        <p class="c_p">
          峰会聚集全国供应链金融精英，遍布各行各业，融合不同领域。在场达成合作的案例不计其数<br />
          自助餐、茶歇、合影等环节都是社交的重要组成部分，为参会精英创造沟通空间
        </p>
      </div>
    </div>
    <div class="communication_imgList">
      <div class="img_item">
        <img src="../assets/img/summit/s1.png" alt="" />
      </div>
      <div class="img_item">
        <img src="../assets/img/summit/s2.png" alt="" />
      </div>
      <div class="img_item">
        <img src="../assets/img/summit/s3.png" alt="" />
      </div>
      <div class="img_item">
        <img src="../assets/img/summit/s4.png" alt="" />
      </div>
      <div class="img_item">
        <img src="../assets/img/summit/s5.png" alt="" />
      </div>
      <div class="img_item">
        <img src="../assets/img/summit/s6.png" alt="" />
      </div>
      <div class="img_item">
        <img src="../assets/img/summit/s7.png" alt="" />
      </div>
      <div class="img_item">
        <img src="../assets/img/summit/s8.png" alt="" />
      </div>
    </div>
    <div class="instantaneous">
      <div class="w">
        <div class="expert_icon"></div>
        <h2 class="c_h2">
          精彩瞬间
        </h2>
        <div class="instantBx">
          <div class="left">
            <img src="../assets/img/summit/instant1.png" alt="" />
            <img src="../assets/img/summit/instant2.png" alt="" />
          </div>
          <div class="center">
            <img src="../assets/img/summit/instant3.png" alt="" />
            <img src="../assets/img/summit/instant4.png" alt="" />
          </div>
          <div class="right">
            <img src="../assets/img/summit/instant5.png" alt="" />
            <img src="../assets/img/summit/instant6.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'summit',
  data () {
    return {
      list: [
        {
          id: 1,
          name: '李海平',
          desc: '海平创新知识服务公司创始人',
          url: require('../assets/img/summit/item1.png')
        },
        {
          id: 2,
          name: '郑艳玲',
          desc: '深圳市物流与供应链管理协会-秘书长',
          url: require('../assets/img/summit/item2.png')
        },
        {
          id: 3,
          name: '罗景雷',
          desc: '前海飞算科技高级合伙人',
          url: require('../assets/img/summit/item3.png')
        },
        {
          id: 4,
          name: '蒋平',
          desc: '重庆大学法学院博士后',
          url: require('../assets/img/summit/jiangping.png')
        },
        {
          id: 5,
          name: '蒋勤',
          desc: '西陇科学互联网事业部总经理',
          url: require('../assets/img/summit/item5.png')
        },
        {
          id: 6,
          name: '赖国逵',
          desc: '海平创新知识服务公司方案专家',
          url: require('../assets/img/divinemap/photo.jpg')
        },
        {
          id: 7,
          name: '文健君',
          desc: '中欧国际工商学院特聘专家',
          url: require('../assets/img/summit/item7.png')
        },
        {
          id: 8,
          name: '魏丽霞',
          desc: '三瑞供应链创始人兼CEO',
          url: require('../assets/img/summit/item8.png')
        },
        {
          id: 9,
          name: '童章宇',
          desc: '连连国际副总裁',
          url: require('../assets/img/summit/item9.png')
        },
        {
          id: 10,
          name: '陈文天',
          desc: '银行票据及供应链金融专家',
          url: require('../assets/img/summit/item10.png')
        },
        {
          id: 11,
          name: '陆德兴',
          desc: '云端信联科技创始人',
          url: require('../assets/img/summit/item11.png')
        },
        {
          id: 12,
          name: '朱光辉',
          desc: '物润船联董事长',
          url: require('../assets/img/summit/item12.png')
        },
        {
          id: 13,
          name: '陈毅',
          desc: '磁云数字副董事长',
          url: require('../assets/img/summit/item13.png')
        },
        {
          id: 14,
          name: '王国文博士',
          desc: '中国物流学会副会长',
          url: require('../assets/img/summit/wangguowen.png')
        },
        {
          id: 15,
          name: '谢东',
          desc: '福虎供应链创始人兼CEO',
          url: require('../assets/img/summit/item15.png')
        },
        {
          id: 16,
          name: '张春燕',
          desc: '德和衡高级联席合伙人',
          url: require('../assets/img/summit/item16.png')
        },
        {
          id: 17,
          name: '张晓宇',
          desc: '深圳海平创新知识服务公司产品交付专家',
          url: require('../assets/img/summit/zhangxiaoyu.png')
        },
        {
          id: 18,
          name: '曹流浪',
          desc: '深圳悦融易科技创始人兼CEO',
          url: require('../assets/img/summit/item18.png')
        },
        {
          id: 19,
          name: '卢轩华',
          desc: '珠海九牛科技有限公司CEO',
          url: require('../assets/img/summit/luxuanhua.png')
        },
        {
          id: 20,
          name: '艾路',
          desc: '深圳海平创新知识服务公司联合创始人兼CTO',
          url: require('../assets/img/summit/ailu.png')
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.summit{
  max-width: 1200px;
  background: #fff;
  margin: auto;
}
.banner {
  display: block;
}

.banner,
.banner .bg {
  position: relative;
  width: 100%;
}

.banner .bg {
  min-height: 312px;
  float: left;
  z-index: 0;
}

.banner .bg_title {
  padding-top: 175px;
  width: 100%;
  position: relative;
  bottom: 220px;
  left: 0;
}

.main {
  background: #160f00;
  height: 100%;
  padding-bottom: 64px;
}

.main .w .bg_title {
  margin-top: 50px;
}

.m {
  display: none;
}

.m .header_m {
  width: 100%;
}

.m .content {
  background: #160f00;
  margin-top: 20px;
}

.m .content .item {
  min-height: 310px;
  margin: auto;
  padding-bottom: 40px;
}

.m .content .item .title_m {
  position: relative;
  margin: auto;
  width: 76px;
  font-size: 36px;
  font-weight: 700;
  color: #d0b26c;
  line-height: 40px;
  background: linear-gradient(0deg, #af8f54, #fae5a4);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.m .content .item .title_m:after {
  position: absolute;
  left: -62%;
  top: 32%;
  content: '';
  width: 177px;
  height: 22px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALEAAAAWBAMAAAB9HmCgAAAAJFBMVEVHcEyoiU+igUypilCpilGpilGpilCpilCpilCoik+pilCpilF1n/a1AAAAC3RSTlMAHwiNzPjtpmpbSvRlB1IAAAEISURBVDjLtZUhD4JQEMePNx3QmBLcKGx8A2YjGUxEZ6K7MZNWCjNYKDaDxeAoRhXc7ssJ742HbK/d48ULv91+7+5/AP0LHKC9ua+uGzGV7K3U9RLJ5OquKgfviExevnyVi7BY0MCWd4oUPsoUijWNPI1ze/fvgwkXDhQfIhlzcLkPJgpX4QKshEz+AuM+zAvvthYujAzJZDwA92G2nRtxLVyUqIHcjF3rw8Sm8zPW3EXw0UHGjd/6MLHKJdlFLeS3I8mdDRZpIYe9DfmD9l4DOf37wX7qXDpZuOimTm4Ky8jk43BT5HbftkRychlud59IDxp58lQmUpuiMxqZqVN0xOQf8VppvrA/r3JjLxBVeTAAAAAASUVORK5CYII=)
    no-repeat;
}

.m .content .item p {
  margin: 4.5rem auto;
  margin-left: 32%;
  font-size: 2rem;
  font-weight: 400;
  color: #94701c;
  line-height: 3rem;
}

.m .content .item .border {
  position: relative;
  margin-top: 3.1875rem;
  width: 52.4375rem;
  height: 32.25rem;
  margin: auto;
  padding: 2.5rem;
}

.m .content .item .border img {
  width: 100%;
  height: 100%;
  background: #15171b;
  border: 3px solid #e7bf82;
  overflow: hidden;
}

.m .content .item .border .image-border {
  position: absolute;
  width: 26px;
  height: 26px;
}

.m .content .item .border .image-border1 {
  top: 0;
  left: 0;
  border-left: 2px solid #fae5a4;
  border-top: 2px solid #fae5a4;
}

.m .content .item .border .image-border2 {
  top: 0;
  right: -2px;
  border-right: 2px solid #fae5a4;
  border-top: 2px solid #fae5a4;
}

.m .content .item .border .image-border3 {
  bottom: 0;
  left: 0;
  border-bottom: 2px solid #fae5a4;
  border-left: 2px solid #fae5a4;
}

.m .content .item .border .image-border4 {
  bottom: 0;
  right: -2px;
  border-right: 2px solid #fae5a4;
  border-bottom: 2px solid #fae5a4;
}

@media screen and (max-width: 1200px) {
  .container .banner,
  .container .main {
    display: none;
  }

  .container .m {
    display: block;
  }

  .container .m img {
    width: 100%;
    height: 100%;
  }
}

:root {
  font-size: 16px !important;
}

body,
html {
  background: #fff;
}

.w {
  overflow: hidden;
}
.w {
  max-width: 1200px;
  height: 100%;
  margin: 0 auto;
}

.bx {
  margin-top: 260px;
  margin-bottom: 100px;
  height: 600px;
}

.swiper-container {
  width: 100%;
  height: 658px;
  object-fit: cover;
}

.swiper-slide {
  width: 100%;
  text-align: center;
  font-size: 18px;
  background: #fff;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: center;
  justify-content: center;
  -ms-flex-align: center;
  align-items: center;
}

.swiper-button-next:after,
.swiper-button-prev:after {
  width: 21px;
  height: 40px;
  opacity: 0.3;
  color: #000;
}

.banner {
  position: relative;
  padding-top: 30px;
  height: 994px;
  background: #a60a16;
  // background: linear-gradient(to right, #e24b2d, #d5234d);
  text-align: center;
  overflow: unset;
}

.banner .banner_icon {
  width: 128px;
  height: 116px;
  background: url(data:image/png;base64,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)
    no-repeat;
  margin: auto;
}

.banner .en {
  margin-top: 10px;
  font-size: 18px;
  font-weight: 300;
  color: #fff;
  line-height: 24px;
  opacity: 0.4;
  text-transform: uppercase;
  letter-spacing: 10px;
}

.banner h1 {
  font-size: 80px;
  font-weight: 700;
  line-height: 86px;
}

.banner .date,
.banner h1 {
  color: #fff;
  letter-spacing: 2px;
}

.banner .date {
  margin-top: 29px;
  font-size: 24px;
  font-weight: 400;
  line-height: 34px;
}

.banner .banner_btn {
  cursor: pointer;
  margin-top: 57px;
  display: flex;
}

.banner .banner_btn div {
  font-size: 20px;
  width: 184px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: #fff;
  border-radius: 10px;
  margin-left: 300px;
}

.banner .banner_btn div a {
  color: #d9001b;
  text-decoration: none;
}

.banner .banner_btn div:first-child {
  margin-left: 320px;
}

.banner .banner_btn div:nth-child(2) {
  margin-left: 148px;
}
.videoWrap{
  text-align: center;
  // margin-top: -340px;
  margin-bottom: 20px;
  position: relative;
}
.video-box-row{
  display: flex;
  justify-content: space-between;
  margin: 20px auto;
  max-width: 1086px;
  height: 460px;
  background: #fff;
  box-shadow: 0 24px 32px 0 hsla(0, 0%, 41%, 0.12);
  border-radius: 10px;
  padding: 30px;
  box-sizing: border-box;
  video{
    width: 100%;
    height: calc(100% - 50px);
    object-fit: cover;
  }
  .video-item{
    width: calc(50% - 50px);
    border: 1px solid #a60a16;
    border-radius: 10px;
    padding: 20px;
    color: #a60a16;
    .title{
      font-size: 24px;
      font-family: 'huaweihongmengcuti', '楷体';
      font-weight: bold;
      margin-bottom: 20px;
    }
  }
}
.video-box{
  display: flex;
  margin: 20px auto;
  max-width: 1086px;
  height: 520px;
  background: #fff;
  box-shadow: 0 24px 32px 0 hsla(0, 0%, 41%, 0.12);
  border-radius: 10px;
  padding: 30px;
  box-sizing: border-box;
  .video-left{
    width: 45%;
    border: 1px solid #a60a16;
    border-radius: 10px;
    padding: 20px;
    color: #a60a16;
    .title{
      font-size: 24px;
      font-family: 'huaweihongmengcuti', '楷体';
      font-weight: bold;
      margin-bottom: 20px;
    }
    .content{
      font-size: 14px;
      font-family: 'huaweihongmengheiti', '黑体';
      text-align: left;
      line-height: 21px;
      p{
        margin: 16px 0;
      }
    }
  }
  .video-right{
    width: calc(55% - 10px);
    margin-left: 10px;
    border: 1px solid #a60a16;
    border-radius: 10px;
    padding: 10px;
  }
}
.videoBx {
  // position: absolute;
  margin: auto;
  max-width: 1086px;
  height: 652px;
  background: #fff;
  box-shadow: 0 24px 32px 0 hsla(0, 0%, 41%, 0.12);
  border-radius: 10px;
  // bottom: -50%;
  // left: 50%;
  // transform: translate(-50%, 0);
  padding: 30px;
  box-sizing: border-box;
}

.videoBx video, .video-box video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

video {
  position: relative;
  z-index: 1;
}

video:focus {
  outline: none;
}

.expert {
  width: 100%;
  // margin-top: 200px;
  height: 540px;
  background: #fff;
  overflow: hidden;
}

.expert .expert_icon {
  width: 96px;
  height: 66px;
  background: url(data:image/png;base64,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)
    no-repeat;
}

.expert .w {
  background: url('../assets/img/summit/expert.png') no-repeat;
  background-position: bottom;
  background-size: 100%;
}

.imgList {
  position: relative;
  background: linear-gradient(to right, #e24b2d, #d5234d);
  overflow: hidden;
}

.imgList .bg {
  width: 100%;
  height: 100%;
  position: absolute;
}

.imgList .w {
  padding: 135px 0;
  display: flex;
  flex-wrap: wrap;
}

.imgList .item {
  position: relative;
  // float: left;
  margin-right: 2%;
  margin-bottom: 2%;
  width: 23.5%;
  height: 350px;
  padding-top: 10px;
  background: #e8e9eb;
  // border: 5px solid #fff;
  box-shadow: 0 12px 18px 0 rgba(5, 4, 4, 0.08);
  background: #fff;
  z-index: 1;
}

.imgList .item .imgBx {
  height: 246px;
  text-align: center;
  overflow: hidden;
}

.imgList .item h5 {
  margin-top: 15px;
  margin-left: 16px;
  height: 18px;
  font-size: 18px;
  font-weight: 700;
  color: #e24b2d;
  line-height: 24px;
}

.imgList .item p {
  margin-top: 6px;
  margin-left: 16px;
  height: 14px;
  font-size: 14px;
  font-weight: 400;
  color: #696969;
  line-height: 24px;
}

.imgList .item:nth-child(4n) {
  margin-right: 0;
}

.enterprise {
  height: 1000px;
}

.enterprise .expert_icon {
  width: 96px;
  height: 66px;
  background: url(data:image/png;base64,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)
    no-repeat;
}

.communication {
  padding-bottom: 49px;
}

.communication .expert_icon {
  width: 96px;
  height: 66px;
  background: url(data:image/png;base64,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)
    no-repeat;
}

.communication_imgList {
  width: 100%;
  height: 730px;
  overflow: hidden;
}

.communication_imgList .img_item {
  float: left;
  width: 24.9%;
  height: 360px;
  margin-right: 1px;
  margin-bottom: 1px;
  overflow: hidden;
}

.communication_imgList .img_item img {
  width: 100%;
  min-height: 360px;
  object-fit: revert;
}

.instantaneous {
  padding-bottom: 50px;
}

.instantaneous .expert_icon {
  width: 96px;
  height: 66px;
  background: url(data:image/png;base64,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)
    no-repeat;
}

.instantaneous .w {
  overflow: unset;
}

.instantaneous .instantBx {
  margin-top: 48px;
  height: 745px;
}

.instantaneous .instantBx div {
  float: left;
  width: 30%;
  height: 100%;
  margin: 0 14px;
  overflow: hidden;
  text-align: center;
}

.instantaneous .w .instantBx div img:nth-child(2) {
  margin-top: 30px;
}

.expert_icon {
  width: 48px;
  height: 48px;
  background: #f90;
  margin: 40px auto;
}

.c_h2 {
  font-size: 32px;
  font-weight: 700;
  line-height: 0;
}

.c_h2,
.c_p {
  color: #2f2f33;
  text-align: center;
}

.c_p {
  margin-top: 32px;
  font-size: 18px;
  font-weight: 400;
  line-height: 30px;
}

@media screen and (max-width: 1170px) {
  body,
  html {
    min-width: 1170px;
  }

  .communication_imgList {
    height: auto;
    padding: 20px;
    box-sizing: border-box;
  }

  .communication_imgList .img_item {
    width: 49%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/summit.vue